import { BaseMapper } from '@shared/data';
import {
    CofusMedicalDocumentationBodyDto,
    GeneraliMedicalDocumentationBodyDto,
    MedicalDocumentationBodyDto,
    MedicalDocumentationBodyDtoUnion,
    MedicalDocumentBodyDto,
} from '../../../app-layers/infrastructure/interface/dto/documentation/medical-documentation-body-dto';
import {
    CofusMedicalDocumentationBodyModel,
    GeneraliMedicalDocumentationBodyModel,
    MedicalDocumentationBodyModel,
    MedicalDocumentBodyModel,
} from '../../interface/documentation/medical-documentation-body-model';

export class MedicalDocumentationBodyMapper extends BaseMapper<MedicalDocumentationBodyModel, MedicalDocumentationBodyDto> {
    public mapDtoToModel(dto: MedicalDocumentationBodyDto): MedicalDocumentationBodyModel {
        if (dto.type === 'GENERALI') {
            return this.mapGeneraliDtoToModel(dto as GeneraliMedicalDocumentationBodyDto);
        } else if (dto.type === 'COFUS') {
            return this.mapCofusDtoToModel(dto as CofusMedicalDocumentationBodyDto);
        } else {
            throw new Error(`Unsupported MedicalDocumentationType: ${dto.type}`);
        }
    }

    private mapGeneraliDtoToModel(dto: GeneraliMedicalDocumentationBodyDto): GeneraliMedicalDocumentationBodyModel {
        return {
            customerId: dto.customerId,
            medicalCareType: dto.medicalCareType,
            accidentDate: this.stringDateToDayjs(dto.accidentDate),
            pastMedicalConditions: dto.pastMedicalConditions,
            pastMedicalConditionsDescription: dto.pastMedicalConditionsDescription,
            type: dto.type,
            visitId: dto.visitId,
            portfolioPaperId: dto.portfolioPaperId,
            portfolioPaperVersion: dto.portfolioPaperVersion,
            medicalOperationNeeded: dto.medicalOperationNeeded,
            medicalHistory: dto.medicalHistory,
            diagnosisCode: dto.diagnosisCode,
            diagnosisDescription: dto.diagnosisDescription,
            visitDateTime: this.stringDateToDayjs(dto.visitDateTime),
            visitType: dto.visitType,
        };
    }

    private mapCofusDtoToModel(dto: CofusMedicalDocumentationBodyDto): CofusMedicalDocumentationBodyModel {
        return {
            customerId: dto.customerId,
            medicalCareType: dto.medicalCareType,
            accidentDate: this.stringDateToDayjs(dto.accidentDate),
            pastMedicalConditions: dto.pastMedicalConditions,
            pastMedicalConditionsDescription: dto.pastMedicalConditionsDescription,
            type: dto.type,
            id: dto.id,
            maskedDocumentIds: dto.maskedDocumentIds,
            descriptionOfOccurrence: dto.descriptionOfOccurrence,
            customerComment: dto.customerComment,
        };
    }

    private mapDocumentDtoToModel(dto: MedicalDocumentBodyDto): MedicalDocumentBodyModel {
        return {
            fileName: dto.fileName,
            contentType: dto.contentType,
            base64EncodedBytes: dto.base64EncodedBytes,
        };
    }

    override mapModelToDto(model: MedicalDocumentationBodyModel): MedicalDocumentationBodyDtoUnion {
        if (model.type === 'GENERALI') {
            return this.mapGeneraliModelToDto(model as GeneraliMedicalDocumentationBodyModel);
        } else if (model.type === 'COFUS') {
            return this.mapCofusModelToDto(model as CofusMedicalDocumentationBodyModel);
        } else {
            throw new Error(`Unsupported MedicalDocumentationType: ${model.type}`);
        }
    }

    private mapGeneraliModelToDto(model: GeneraliMedicalDocumentationBodyModel): GeneraliMedicalDocumentationBodyDto {
        return {
            customerId: model.customerId,
            medicalCareType: model.medicalCareType,
            accidentDate: this.dayjsFormatForDto(model.accidentDate),
            pastMedicalConditions: model.pastMedicalConditions,
            pastMedicalConditionsDescription: model.pastMedicalConditionsDescription,
            type: model.type,
            visitId: model.visitId,
            portfolioPaperId: model.portfolioPaperId,
            portfolioPaperVersion: model.portfolioPaperVersion,
            medicalOperationNeeded: model.medicalOperationNeeded,
            medicalHistory: model.medicalHistory,
            diagnosisCode: model.diagnosisCode,
            diagnosisDescription: model.diagnosisDescription,
            visitDateTime: this.dayjsFormatForDto(model.visitDateTime),
            visitType: model.visitType,
        };
    }

    private mapCofusModelToDto(model: CofusMedicalDocumentationBodyModel): CofusMedicalDocumentationBodyDto {
        return {
            customerId: model.customerId,
            medicalCareType: model.medicalCareType,
            accidentDate: this.dayjsFormatForDto(model.accidentDate),
            pastMedicalConditions: model.pastMedicalConditions,
            pastMedicalConditionsDescription: model.pastMedicalConditionsDescription,
            type: model.type,
            maskedDocumentIds: model.maskedDocumentIds,
            id: model.id,
            descriptionOfOccurrence: model.descriptionOfOccurrence,
            customerComment: model.customerComment,
        };
    }

    private mapDocumentModelToDto(model: MedicalDocumentBodyModel): MedicalDocumentBodyDto {
        return {
            fileName: model.fileName,
            contentType: model.contentType,
            base64EncodedBytes: model.base64EncodedBytes,
        };
    }
}
